import authHeader from "@/services/auth-header";

const API_URL='https://www.dev.ekhonidaktar.com/api';

class UpdatePatientService {

    updatePatient(patient_id, form){
        return form.put(`${API_URL}/patients/${patient_id}`, {headers: authHeader()});
    }

}

export default new UpdatePatientService();